import { createAction, props } from '@ngrx/store';
import { LobbyCheckIn } from '../../../shared/models/lobby-check-in';

export const loadLobbyDetails = createAction(
    '[CheckIn Page] Load Lobby Details',
    props<{ locationId: number }>()
);

export const loadServices = createAction(
    '[CheckIn Page] Load Services',
    props<{ locationId: number,showInLobby:boolean,showCategory:boolean }>()
);

export const loadStaffMembers = createAction(
    '[CheckIn Page] Load Staff Members',
    props<{ tenantId: number, locationId: number,showInLobby:boolean }>()
);

export const setLocationId = createAction(
    '[CheckIn Page] Set LocationId',
    props<{ locationId: number }>()
);

export const setTimezoneId = createAction(
    '[CheckIn Page] Set TimezoneId',
    props<{ timezoneId: string }>()
);

export const setTenantId = createAction(
    '[CheckIn Page] Set TenantId',
    props<{ tenantId: number }>()
);

export const addToLobby = createAction(
    '[CheckIn Page] Add To Lobby',
    props<{ lobbyCheckIn: LobbyCheckIn }>()
);

export const instantAssist = createAction(
    '[CheckIn Page] Instant Assist',
    props<{ lobbyCheckIn: LobbyCheckIn, userId: number }>()
);
export const ImpersonateinstantAssist = createAction(
    '[CheckIn Page] Impersonate Instant Assist',
    props<{ lobbyCheckIn: LobbyCheckIn, userId: number,impersonateByName:string}>()
);
export const loadInstantImpersonateAssist = createAction(
    '[CheckIn Page] Instant Impersonate Assist',
    props<{ show: boolean }>()
);

export const serviceCheckboxChecked = createAction(
    '[CheckIn Page] Service Checkbox Checked',
    props<{ serviceId: number }>()
);

export const serviceCheckboxUnchecked = createAction(
    '[CheckIn Page] Service Checkbox Unchecked',
    props<{ serviceId: number }>()
);

export const serviceFilterValueChange = createAction(
    '[CheckIn Page] Service Filter Value Change',
    props<{ filterValue: string }>()
);

export const spanishSpeakerPreferredChange = createAction(
    '[CheckIn Page] Spanish Speaker Preferred Change',
    props<{ spanishSpeakerPreferred: boolean }>()
);

export const closeCheckInModal = createAction(
    '[CheckIn Page] Close CheckIn Modal'
);
export const setLobbyCheckInPopupFlag = createAction(
    '[CheckIn Page] Change Lobby CheckIn Popup Flag',
    props<{showCheckInPopup: boolean}>()
);

export const readyForTheNextCheckIn = createAction(
    '[CheckIn Page] Ready For The NextCheckIn'
);
